import { render, staticRenderFns } from "./SellBusinessEdit.vue?vue&type=template&id=267b4e65&scoped=true&"
import script from "./SellBusinessEdit.vue?vue&type=script&lang=js&"
export * from "./SellBusinessEdit.vue?vue&type=script&lang=js&"
import style0 from "./SellBusinessEdit.vue?vue&type=style&index=0&id=267b4e65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267b4e65",
  null
  
)

export default component.exports